import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/shared/PasswordInput";
import { Label } from "@/components/ui/label";
import { PasswordStrength } from "@/components/PasswordStrength";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const nav = useNavigate();
  const mismatch = confirm.length > 0 && confirm !== password;

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Hesla se neshodují."); return; }
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Heslo bylo změněno. Přihlaste se.");
      nav("/login");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <AuthShell title="Nové heslo" subtitle="Zadejte nové heslo ke svému účtu">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="password">Nové heslo</Label>
          <PasswordInput id="password" data-testid="reset-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 mt-1.5" minLength={10} required />
          <PasswordStrength password={password} />
        </div>
        <div>
          <Label htmlFor="password2">Nové heslo znovu</Label>
          <PasswordInput id="password2" data-testid="reset-password2" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className={`h-12 mt-1.5 ${mismatch ? "border-destructive focus-visible:ring-destructive" : ""}`} minLength={10} required />
          {mismatch && <p data-testid="reset-password-mismatch" className="text-destructive text-xs mt-1">Hesla se neshodují.</p>}
        </div>
        {error && <div className="text-destructive text-sm">{error}</div>}
        <Button type="submit" data-testid="reset-submit" className="w-full h-12 font-bold">Změnit heslo</Button>
        <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Zpět na přihlášení</Link>
      </form>
    </AuthShell>
  );
}
